import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preparedLink", "innerRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link as ReactRouterLink } from 'react-router-dom';
import { withPreparedLink } from 'hocs';
import { jsx as _jsx } from "react/jsx-runtime";
var Link = /*#__PURE__*/memo(function (_ref) {
  var preparedLink = _ref.preparedLink,
      innerRef = _ref.innerRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(ReactRouterLink, _objectSpread({
    to: preparedLink,
    href: preparedLink,
    innerRef: innerRef
  }, props));
});
Link.propTypes = {
  preparedLink: PropTypes.oneOfType([PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
    state: PropTypes.objectOf(PropTypes.any)
  }), PropTypes.string]).isRequired,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
Link.defaultProps = {
  innerRef: null
};
export default withPreparedLink(Link);